import { DataTableResponse, RecordingItem, HistoryItem } from '@/models/scripts'

export interface RecordingsState {
  list: DataTableResponse
  item: RecordingItem | null
  history: HistoryItem[]
  downloadLink: string
  kanban: {
    [key: string]: {
      [key: string]: DataTableResponse
    }
  }
}

export const initialState: RecordingsState = {
  list: {
    data: [],
    filter: {},
    sort: {},
    pagination: {
      offset: 0,
      limit: 20,
      total: 0,
    },
    columns: [],
  },
  item: null,
  history: [],
  downloadLink: '',
  kanban: {},
}
